import axiosClient from '../axiosClient';
import { EtaStatusEndpoints } from '../endpoints/etaStatus';

export type EtaStatusType = 'GOOD' | 'WARNING' | 'CRITICAL';

export interface IEtaStatusItem {
  id: number;
  status: EtaStatusType;
  message: string;
  enabled: boolean;
  endTime: string | null;
}

export const EtaStatusService = {
  async getAllStatuses(): Promise<IEtaStatusItem[]> {
    const res = await axiosClient.get<IEtaStatusItem[]>(EtaStatusEndpoints.GET_ALL_STATUSES);
    return res.data;
  },

  async enableStatus(id: number): Promise<void> {
    const url = EtaStatusEndpoints.ENABLE_STATUS.replace(':id', id.toString());
    await axiosClient.post(url);
  },

  async sendOrdersDelayed(): Promise<void> {
    await axiosClient.post(EtaStatusEndpoints.SEND_ORDERS_DELAYED);
  },
};
